import React, { useMemo } from 'react';
import { HelpCircle } from 'lucide-react';
import type { Establecimiento } from '@/modelos/Establecimiento';
import type { ProductFormData } from '@/modelos/productos/Producto';
import Tooltip from '@/contasis/components/Tooltip/Tooltip';
import { MultiSelect } from '@/contasis';

interface ProductAvailabilitySectionProps {
  formData: ProductFormData;
  setFormData: React.Dispatch<React.SetStateAction<ProductFormData>>;
  Establecimientos: Establecimiento[];
  showCheck?: boolean;
  onFieldTouched?: () => void;
  renderCheck?: (className?: string) => React.ReactNode;
}

export const ProductAvailabilitySection: React.FC<ProductAvailabilitySectionProps> = ({
  formData,
  setFormData,
  Establecimientos,
  showCheck,
  onFieldTouched,
  renderCheck
}) => {
  const activeEstablecimientos = useMemo(
    () => Establecimientos.filter(est => est.esActivo !== false),
    [Establecimientos]
  );

  if (activeEstablecimientos.length <= 1) return null;

  const options = activeEstablecimientos.map(est => ({
    value: est.id,
    label: est.nombre,
    code: est.codigo,
  }));

  const tooltipAction = (
    <span className="flex items-center gap-1">
      {showCheck && renderCheck?.()}
      <Tooltip text="Define en qué establecimientos se podrá vender este producto." position="right">
        <button
          type="button"
          aria-label="Ayuda: Disponibilidad"
          className="inline-flex items-center justify-center rounded-sm text-gray-400 hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/40"
        >
          <HelpCircle className="w-4 h-4" />
        </button>
      </Tooltip>
    </span>
  );

  return (
    <MultiSelect
      label="Disponibilidad"
      labelAction={tooltipAction}
      options={options}
      value={formData.establecimientoIds}
      onChange={(ids) => {
        setFormData(prev => ({ ...prev, establecimientoIds: ids }));
        onFieldTouched?.();
      }}
      size="small"
      selectAllLabel="Todas las sedes"
      allSelectedLabel="Todas las sedes"
      placeholder="Ninguna sede seleccionada"
    />
  );
};


